import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import PropertiesForSalePage from "./pages/PropertiesForSalePage.tsx";
import PropertiesForRentPage from "./pages/PropertiesForRentPage.tsx";
import PropertyDetailsPage from "./pages/PropertyDetailsPage.tsx";
import ServicesPage from "./pages/ServicesPage.tsx";
import AboutPage from "./pages/AboutPage.tsx";
import ContactPage from "./pages/ContactPage.tsx";
import LocationsPage from "./pages/LocationsPage.tsx";
import LocationDetailsPage from "./pages/LocationDetailsPage.tsx";
import OffPlanInvestmentsPage from "./pages/OffPlanInvestmentsPage.tsx";
import LoginPage from "./pages/LoginPage.tsx";
import AdminPage from "./pages/AdminPage.tsx";
import SearchResultsPage from "./pages/SearchResultsPage.tsx";
import NotFound from "./pages/NotFound.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/properties-for-sale" element={<PropertiesForSalePage />} />
          <Route path="/properties-for-rent" element={<PropertiesForRentPage />} />
          <Route path="/property/:id" element={<PropertyDetailsPage />} />
          <Route path="/search-results" element={<SearchResultsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/locations" element={<LocationsPage />} />
          <Route path="/locations/:slug" element={<LocationDetailsPage />} />
          <Route path="/off-plan-investments" element={<OffPlanInvestmentsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminPage />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
